import TabNavigation from "Components/common/TabNavigation";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { userDetail } from "Stores/userDetail";
import ConnectedAccountsRouting from "../Crm/ConnectedAccountsRouting";
import ConnectEmailButton from "./ConnectEmailButton";
import { linkedInReplyState } from "./LinkedInAccounts/state";
import { whatsAppReplyState } from "./WhatsAppAccounts/state";

export const getConnectedAccountList = () => {
  const storedDisabledFeatures = userDetail?.featuresDisabled;

  const disabledFeatureSet = storedDisabledFeatures
    ? new Set(storedDisabledFeatures)
    : null;
  const connectAccounts = [
    {
      name: "Email",
      id: "email",
      path: "email",
      featureTitle: "EMAIL"
    },

    {
      name: "WhatsApp",
      id: "whatsapp",
      path: "whatsapp",
      featureTitle: "WHATSAPP"
    },

    {
      name: "LinkedIn",
      id: "linkedin",
      path: "linkedin",
      featureTitle: "LINKEDIN_AUTOMATION"
    },

    {
      name: "Sequences",
      id: "sequences",
      path: "sequences"
    }
  ];

  const filteredConnectedAccountList = disabledFeatureSet
    ? connectAccounts.filter(item => !disabledFeatureSet.has(item.featureTitle))
    : connectAccounts;
  return filteredConnectedAccountList;
};

const ConnectedAccounts = observer((props = {}) => {
  const [showEmailConfigure, setShowEmailConfigure] = useState(false);
  const [showSmtpImapConnect, setSmtpImapConnect] = useState(false);
  const [activeTab, setActiveTab] = useState("");
  const location = useLocation();
  const [connectedAccountList, setConnectedAccountList] = useState(() => {
    return getConnectedAccountList();
  });

  const emailProps = {
    showEmailConfigure,
    showSmtpImapConnect,
    setSmtpImapConnect,
    setShowEmailConfigure
  };

  useEffect(() => {
    const tempActiveTab = location?.pathname?.split("/").pop();
    setActiveTab(tempActiveTab);
  }, [location]);

  useEffect(() => {
    const tempSideBarList = getConnectedAccountList();
    setConnectedAccountList(tempSideBarList);
  }, [userDetail?.featuresDisabled]);

  return (
    <div className="connectedAccountsView">
      <div className="connectedAccountsHeader">
        {!showEmailConfigure &&
          !showSmtpImapConnect &&
          !linkedInReplyState?.showConfigure &&
          !whatsAppReplyState?.showConfigure && (
            <TabNavigation tabList={connectedAccountList} />
          )}
        {activeTab === "email" && <ConnectEmailButton {...emailProps} />}
        {/* {Hiding it As Per prem's Instructions. We can enable it in future if needed } */}
        {/* {activeTab === "linkedin" && !linkedInReplyState?.showConfigure && (
          <ConnectedLinkedInButton />
        )} */}
      </div>
      <ConnectedAccountsRouting {...props} {...emailProps} />
    </div>
  );
});

export default ConnectedAccounts;
export { ConnectedAccounts };
